import React from 'react'
import { bindActionCreators } from 'redux'
import * as polyglotActions from '../../redux/polyglot/actions'
import Login from './Login'
import { connect } from 'react-redux'
import { getLocale } from '../../resources/translations'
import { polyglot as polyglotInstance } from '../../index'

class LoginContainer extends React.Component {
  componentDidMount () {
    if (!this.props.hasTranslations) {
      this.props.replaceTranslations(getLocale())
    } else {
      this.props.setTranslations(this.props.locale)
    }
  }
  render () {
    const {polyglotReady, ...passThroughProps} = this.props
    if (polyglotReady) {
      return <Login {...passThroughProps} />
    } else {
      return <div>Loading</div>
    }
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators(polyglotActions, dispatch)
}

function mapStateToProps ({polyglot}) {
  return {
    locale: polyglot.locale,
    hasTranslations: polyglot.hasTranslations,
    polyglotReady: polyglot && Object.keys(polyglotInstance.phrases).length > 0
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer)
